import React, { useState } from "react";
import { connect } from "react-redux";
import { createProject } from "./actions";

const NewProjectForm = ({ projects = [], onCreatePressed }) => {


    const [name, setName] = useState('');
    const [start_date, setStartDate] = useState('');
    const [end_date, setEndDate] = useState('');
    const [role, setRole] = useState('Frontend Developer');
    const [url, setUrl] = useState('');
    const [description, setDescription] = useState('');
    const [githubUrl, setGithubUrl] = useState('');
    const [teamSize, setTeamSize] = useState('');
    const [document, setDocument] = useState('');

    return (
        <div className="border rounded bg-light p-3 m-2">
            <div style={{ marginBottom: '10px' }}>
                <div>
                    <div>
                        <label style={{ margin: '0', padding: '0', marginBottom: '5px' }} htmlFor="position">Project Title</label>
                        <input
                            className="form-control form-control-sm mb-2"
                            type="text"
                            placeholder="Project Title"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            name="name"
                            style={{ margin: 0, padding: '7px' }}
                        />
                    </div>
                </div>
            </div>
            <div style={{ marginBottom: '10px', display: 'flex', gap: '10px' }}>
                <div>
                    <label style={{ margin: '0', padding: '0', marginBottom: '5px', display: 'block' }} htmlFor="position">Start Date</label>
                    <input
                        className="form-control form-control-sm mb-2"
                        type="month"
                        placeholder="Project Link"
                        value={start_date}
                        onChange={(e) => setStartDate(e.target.value)}
                        name="start_date"
                        style={{ margin: 0, padding: '7px', width: '200px' }}
                    />
                </div>
                <div>
                    <label style={{ margin: '0', padding: '0', marginBottom: '5px', display: 'block' }} htmlFor="position">End Date</label>
                    <input
                        className="form-control form-control-sm mb-2"
                        type="month"
                        placeholder="Project Link"
                        value={end_date}
                        onChange={(e) => setEndDate(e.target.value)}
                        name="end_date"
                        style={{ margin: 0, padding: '7px', width: '200px' }}
                    />
                </div>
                <div className="role">
                    <label style={{ margin: '0', padding: '0', marginBottom: '5px', display: 'block' }} htmlFor="position">Your Role</label>
                    <select className="form-control mb-2" name="role" onChange={(e) => setRole(e.target.value)}
                        style={{ margin: 0, padding: '7px' }}
                    >
                        <option value="Frontend Developer">Frontend Developer</option>
                        <option value="Backend Developer">Backend Developer</option>
                        <option value="Fullstack Developer">Fullstack Developer</option>
                        <option value="UI/UX Designer">UI/UX Designer</option>
                        <option value="Project Manager">Project Manager</option>
                        <option value="Data Scientist">Data Scientist</option>
                        <option value="Data Analyst">Data Analyst</option>
                        <option value="Business Analyst">Business Analyst</option>
                        <option value="Software Engineer">Software Engineer</option>
                        <option value="DevOps Engineer">DevOps Engineer</option>
                        <option value="QA Engineer">QA Engineer</option>
                        <option value="Project Leader">Project Leader</option>
                        <option value="Team Leader">Team Leader</option>
                        <option value="Team Member">Team Member</option>
                        <option value="Other">Other</option>
                    </select>
                </div>
                <div>
                    <label style={{ margin: '0', padding: '0', marginBottom: '5px', display: 'block' }} htmlFor="position">Team Size</label>
                    <input
                        className="form-control form-control-sm mb-2"
                        type="number"
                        placeholder="Team Size"
                        value={teamSize}
                        onChange={(e) => setTeamSize(e.target.value)}
                        name="teamSize"
                        style={{ margin: 0, width: '280px' }}
                    />
                </div>
                {/* upload */}
            </div>
            <div style={{ display: 'flex', gap: '10px', alignItems: 'center', marginBottom: '10px' }}>
                <div>
                    <label style={{ margin: '0', padding: '0', marginBottom: '5px', display: 'block' }} htmlFor="position">Document</label>
                    <input
                        className="form-control form-control-sm mb-2"
                        type="file"
                        placeholder="Document"
                        value={document}
                        onChange={(e) => setDocument(e.target.value)}
                        name="document"
                        style={{ margin: 0, width: '250px', padding: '5px' }}
                    />
                </div>
                <div>
                    <label style={{ margin: '0', padding: '0', marginBottom: '5px', display: 'block' }} htmlFor="position">Project Link</label>
                    <input
                        className="form-control form-control-sm mb-2"
                        type="text"
                        placeholder="Project Link"
                        value={url}
                        onChange={(e) => setUrl(e.target.value)}
                        name="url"
                        style={{ margin: 0, width: '350px' }}
                    />
                </div>
                <div>
                    <label style={{ margin: '0', padding: '0', marginBottom: '5px', display: 'block' }} htmlFor="position">Github Link</label>
                    <input
                        className="form-control form-control-sm mb-2"
                        type="text"
                        placeholder="Github Link"
                        value={githubUrl}
                        onChange={(e) => setGithubUrl(e.target.value)}
                        name="githubUrl"
                        style={{ margin: 0, width: '350px' }}
                    />
                </div>
            </div>
            <div>
                <label style={{ margin: '0', padding: '0', marginBottom: '5px' }} htmlFor="position">Project Description</label>
                <textarea
                    className="form-control form-control-sm mb-2"
                    type="text"
                    placeholder="Project Description"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    name="description"
                />
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '10px' }}>
                <button
                    className="btn btn-success btn-sm rounded-circle"
                    disabled={
                        !name || !url || !description || !start_date
                    }
                    onClick={() => onCreatePressed({ name, start_date, end_date, role, url, githubUrl, description, document, teamSize })}
                >
                    Add
                </button>
            </div>
        </div>
    )
}


const mapStateToProps = state => ({
    projects: state.projects,
});

const mapDispatchToProps = dispatch => ({
    onCreatePressed: project => dispatch(createProject(project)),
});

export default connect(mapStateToProps, mapDispatchToProps)(NewProjectForm);


// export default connect(null, { createProject })(NewProjectForm);
